// Support page - uses tenant branding when on tenant subdomain. Phone number removed.
import React from "react"
import { Link } from "react-router-dom"
import { useBranding } from "@/contexts/branding-context"
import { getCurrentTenantId } from "@/lib/tenant"

export default function SupportPage() {
  const tenantId = getCurrentTenantId()
  const { logoUrl, businessName, supportName, supportEmail, supportAddress } = useBranding()

  const displayName = supportName
  const logoSrc = tenantId && logoUrl ? logoUrl : "/logo-with-text.png"
  const contactEmail = supportEmail || "support@thenotfit.com"
  const contactAddress = supportAddress || (!tenantId ? "Rruga Komuna e Parisit, Tirane, Albania" : "")

  return (
    <main className="max-w-2xl mx-auto py-16 px-4">
      <Link to="/" className="flex justify-center mb-8">
        <img src={logoSrc} alt={`${businessName} Logo`} className="h-16 w-auto" />
      </Link>
      <h1 className="text-3xl font-bold mb-6">{displayName}</h1>
      <p className="mb-4">If you need assistance or have any questions about your membership, please contact us:</p>
      <ul className="list-disc ml-6 mb-4">
        <li>Email: <a href={`mailto:${contactEmail}`} className="text-blue-600 underline">{contactEmail}</a></li>
        {contactAddress ? <li>Address: {contactAddress}</li> : null}
      </ul>
      <p className="mb-4">Our support team is available during regular gym hours. We aim to respond to all inquiries within 24 hours.</p>
      <p className="mt-8 text-sm text-muted-foreground">Thank you for being a part of {businessName}!</p>
    </main>
  )
}
